import { IApplication, IProduct } from '../../models';

export type SetApplicationSuccess = {
  type: 'set_application_success',
  application: IApplication | null
};

export type SetInputSuccss = {
  type: 'set_input_success',
  inputs: Map<string, string>
};

export type HandleNextClick = {
  type: 'next_click_success',
  filters: Map<string, string>
};

export type HandlePreviousClick = {
  type: 'previous_click_success'
};

export type HandleResetClick = {
  type: 'reset_click_success'
};

export type HandleShowResultsClick = {
  type: 'showresults_click_success',
  selection: Map<string, string> | null
};

export type HandleResultSelectedClick = {
  type: 'resultselected_click_success',
  product: IProduct | null
};

export const setApplication = (application: IApplication | null): SetApplicationSuccess => {
  return {
    type: 'set_application_success',
    application
  };
};

export const setInput = (inputs: Map<string, string>): SetInputSuccss => {
  return {
    type: 'set_input_success',
    inputs
  };
};

export const handleNextClick = (filters: Map<string, string>) => {
  return {
    type: 'next_click_success',
    filters
  };
};

export const handlePreviousClick = () => {
  return {
    type: 'previous_click_success'
  };
};

export const handleResetClick = () => {
  return {
    type: 'reset_click_success'
  };
};

export const handleShowResultsClick = () => {
  return {
    type: 'showresults_click_success'
  };
};

export const handleResultSelectedClick = (product: IProduct) => {
  return {
    type: 'resultselected_click_success',
    product
  };
};

export type AppActions =
  | SetApplicationSuccess
  | SetInputSuccss
  | HandleNextClick
  | HandlePreviousClick
  | HandleShowResultsClick
  | HandleResultSelectedClick
  | HandleResetClick;
